var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('div',{staticClass:"b-main-content"},[_c('h2',[_vm._v("Smartpress")]),_c('p',[_c('b-button',{attrs:{"variant":"outline-dark","to":"signUp"}},[_vm._v("Sign Up")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }